var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.012 0L7.2 8.273.973 14.999h1.402l5.452-5.888 4.404 5.888H17l-6.536-8.738L16.26 0h-1.402l-5.02 5.424L5.782 0h-4.77zm2.06 1.032h2.191l9.674 12.935h-2.19L3.073 1.032z",
    fill: "#1C2631"
  })));
}

export default SvgXinline;